import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import AlertBanner from "components/displays/alertBanner";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { freeTextFormProps } from "../../../../styled/props/textFieldProps";
import InfoLine from "../../../displays/infoLine";
import DeliveryLocSearchAsYouType from "../../../inputs/searchAsYouType/deliveryLocSearchAsYouType";
import { headerFormGridColumnProps } from "./headerFormGridLayout";

const guideNote = [
    "'General' and 'Accounting' - Information input in these fields will automatically be applied to all requisition lines. You will have the opportunity to edit in the next page.",
    "'Delivery' - If you select Input One Time Delivery Address, the information you enter will automatically be applied to all requisition lines. You will NOT have the opportunity to edit in the next page.",
    "You will be able to attach files to the requisition header and/or lines in the next page.",
];
const Section3Delivery = ({ disabled, updateHeader }) => {
    // Collect states and state dispatchers
    const headerForm = useSelector(
        (state) => state.createRequisition.iBuyRequisition.requisitionHeaderForm
    );

    const isInternalReq = useSelector(
        (state) => state.createRequisition.isInternalReq
    );

    const hasAddressType = useSelector(
        (state) => state.createRequisition.iBuyRequisition.ADDRESS_TYPE
    );

    /**
     * Called when a delivery location is selected/cleared by user.
     * @param {Object} value - the obj returned from the `onChange`
     * method on the autocomplete
     * {"LOCATION_ID": 123, "LOCATION_CODE": "Name"}
     */
    const onSelectDeliveryLoc = (value) => {
        const locCode = value?.LOCATION_CODE || null;
        const locId = value?.LOCATION_ID || null;
        const addressType = value?.ADDRESS_TYPE || null;
        const selectedOneTimeAddress = value?.SELECTED_ONE_TIME_ADDRESS || null;
        const oneTimeAddress = value?.ONE_TIME_ADDRESS || null;
        const oneTimeAddressCountry = value?.ONE_TIME_ADDRESS_COUNTRY || null;
        const storeNewOTDAddress = value?.STORE_ONE_TIME_ADDRESS || null;
        const saveAddressForFuture = value?.SAVE_ADDRESS_FOR_FUTURE || null;

        // Update form lookups
        updateHeader(locId, "DELIVER_TO_LOCATION_ID");
        updateHeader(locCode, "LOCATION_CODE");
        updateHeader(addressType, "ADDRESS_TYPE");
        updateHeader(storeNewOTDAddress, "STORE_ONE_TIME_ADDRESS");
        updateHeader(oneTimeAddress, "ONE_TIME_ADDRESS");
        updateHeader(oneTimeAddressCountry, "ONE_TIME_ADDRESS_COUNTRY");
        updateHeader(selectedOneTimeAddress, "SELECTED_ONE_TIME_ADDRESS");
        updateHeader(saveAddressForFuture, "SAVE_ADDRESS_FOR_FUTURE");
    };

    const onSwitchDelivery = (switchTo) => {
        if (switchTo === "otda") {
            updateHeader(undefined, "DELIVER_TO_LOCATION_ID");
            updateHeader(undefined, "LOCATION_CODE");
            updateHeader("otda", "ADDRESS_TYPE");
        }
        if (switchTo === "standard") {
            updateHeader(undefined, "SELECTED_ONE_TIME_ADDRESS");
            updateHeader(undefined, "ONE_TIME_ADDRESS");
            updateHeader(undefined, "ONE_TIME_ADDRESS_COUNTRY");
            updateHeader(undefined, "SAVE_ADDRESS_FOR_FUTURE");
            updateHeader(undefined, "STORE_ONE_TIME_ADDRESS");
            updateHeader("standard", "ADDRESS_TYPE");
        }
    };

    const selectedDeliveryLoc =
        headerForm?.ADDRESS_TYPE && headerForm?.ADDRESS_TYPE === "standard"
            ? headerForm?.DELIVER_TO_LOCATION_ID && headerForm?.LOCATION_CODE
                ? {
                      LOCATION_ID: headerForm.DELIVER_TO_LOCATION_ID,
                      LOCATION_CODE: headerForm?.LOCATION_CODE,
                      ADDRESS_TYPE: headerForm.ADDRESS_TYPE,
                  }
                : null
            : headerForm?.ADDRESS_TYPE === "otda"
            ? {
                  SELECTED_ONE_TIME_ADDRESS:
                      headerForm.SELECTED_ONE_TIME_ADDRESS,
                  ONE_TIME_ADDRESS: headerForm.ONE_TIME_ADDRESS,
                  ONE_TIME_ADDRESS_COUNTRY: headerForm.ONE_TIME_ADDRESS_COUNTRY,
                  SAVE_ADDRESS_FOR_FUTURE: headerForm.SAVE_ADDRESS_FOR_FUTURE,
                  ADDRESS_TYPE: headerForm.ADDRESS_TYPE,
              }
            : null;

    return (
        <Grid {...headerFormGridColumnProps}>
            <Grid item xs={12}>
                <Typography variant="h5" color="text.subheader">
                    Delivery Options
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <DeliveryLocSearchAsYouType
                    selectedDeliveryLoc={selectedDeliveryLoc}
                    onSelectDeliveryLoc={onSelectDeliveryLoc}
                    hasAddressType={hasAddressType}
                    onSwitchMultiDeliveryOption={onSwitchDelivery}
                    shouldShowOTA={!isInternalReq}
                    disabled={disabled}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    {...freeTextFormProps}
                    label="Note to Receiver (Max 480 Characters)"
                    multiline
                    onChange={(e) =>
                        updateHeader(e.target.value, "NOTE_TO_RECEIVER")
                    }
                    placeholder="Note to Receiver..."
                    value={headerForm.NOTE_TO_RECEIVER}
                    disabled={disabled}
                    inputProps={{ maxLength: 480 }}
                />
            </Grid>
            <Grid item xs={12}>
                <InfoLine>{guideNote[0]}</InfoLine>
                <InfoLine>{guideNote[1]}</InfoLine>
                <InfoLine>{guideNote[2]}</InfoLine>
            </Grid>
        </Grid>
    );
};

Section3Delivery.propTypes = {
    disabled: PropTypes.any,
    updateHeader: PropTypes.func,
};
export default Section3Delivery;
